export const TRANSFERIR_TIPO_FORM_ID = "transferir-tipo-obra-form";

export const TRANSFERIR_TIPO_TITLE = "Transferir Tipo de Obra";
export const CARREGANDO_LABEL = "Carregando Obras de destino...";
export const TIPO_ROTULO = "Tipo de Obra em transferência";

export const ETAPAS_LABEL = "Etapas da transferência";
export const ETAPA_DESTINO = "Destino";
export const ETAPA_REVISAO = "Revisão";

export const CANCELAR_LABEL = "Cancelar";
export const VOLTAR_LABEL = "Voltar";
export const PROXIMA_LABEL = "Próxima etapa";
export const SOLICITAR_LABEL = "Solicitar transferência";

export const DESTINO_TITLE = "Obra de destino";
export const DESTINO_SUBTITLE = (tipo: string) =>
  `Escolha a Obra que vai receber o Tipo de Obra e os escopos macro dele: ${tipo}.`;
export const AVISO_EMBARCACAO = (embarcacao: string, obra: string) =>
  `Só aparecem Obras da mesma embarcação: ${embarcacao}. A Obra atual (${obra}) não entra na lista.`;
export const AVISO_ESCOLHA_OBRA =
  "Escolha a Obra que vai receber o Tipo de Obra e os escopos macro dele.";
export const AVISO_SEM_OBRA = (embarcacao: string) =>
  `A embarcação ${embarcacao} não tem outra Obra disponível para receber este Tipo de Obra.`;
export const INDISPONIVEL_LABEL = "Indisponível";
export const SEM_CENTRO_CUSTO = "Esta Obra não tem centro de custo receptor para o Tipo de Obra.";
export const DESTINO_OBRIGATORIO = "Selecione a Obra de destino.";
export const CENTRO_CUSTO_OBRIGATORIO = "Selecione o centro de custo de destino.";
export const EMBARCACAO_NAO_INFORMADA = "sem embarcação";

export const TABELA_LABEL = "Obras da mesma embarcação";
export const COLUNA_ID = "ID";
export const COLUNA_STATUS = "Status Financeiro";
export const COLUNA_TIPOS = "Tipos de Obra";
export const COLUNA_CONDICAO = "Condição";
export const COLUNA_INICIO = "Início";
export const COLUNA_TERMINO = "Término";
export const COLUNA_OUTLOOK = "Outlook BRL M";
export const COLUNA_SITUACAO = "Situação";
export const SITUACAO_DISPONIVEL = "Disponível";

export const CENTRO_CUSTO_LABEL = "Centro de custo de destino";
export const CENTRO_CUSTO_PLACEHOLDER = "Selecione o centro de custo";
export const TIPO_JA_EXISTE_AJUDA =
  "O Tipo de Obra já existe neste centro de custo: os escopos entram nele.";

export const CONFIRMAR_TITLE = "Transferir Tipo de Obra";
export const PERGUNTA_CONFIRMACAO = (
  codigo: string,
  nome: string,
  quantidade: number,
  obra: string,
  embarcacao: string,
) =>
  `Tem certeza de que deseja transferir o Tipo de Obra ${codigo} - ${nome} e ${
    quantidade === 1 ? "o escopo macro dele" : `os ${quantidade} escopos macro dele`
  } para a Obra ${obra} (${embarcacao})?`;
/** Figma 14311:1467558 (aviso azul da confirmação). */
export const AVISO_APROVACAO_TRANSFERENCIA = (obraOrigem: string) =>
  `A transferência vai para aprovação, numa solicitação só para as duas Obras. Até a aprovação, o Tipo de Obra e os escopos macro continuam na Obra ${obraOrigem}.`;

/** Provisório, sem texto na HU: o envio é informativo. */
export const ENVIADO_PARA_APROVACAO = "Solicitação de transferência enviada para aprovação.";
/** MS05 (Figma 16777:487691): transferência efetivada na hora, FEL-0→FEL-0. */
export const TRANSFERIDO_MESSAGE = "Tipo de Obra transferido com sucesso.";
export const ERRO_ENVIO_PADRAO = "Não foi possível solicitar a transferência. Tente novamente.";
